module.exports = __webpack_public_path__ + "static/5-Sin Salida-154eecc8234c8140f158732f4873aef6.jpg";